var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagAus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(1960 2973)",
    fill: "#fff",
    opacity: 0.41
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_AUS",
    transform: "translate(-1960 -2973)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_australia",
    transform: "translate(1959.693 2973)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_462",
    "data-name": "Ret\\xE2ngulo 462",
    width: 102.851,
    height: 60,
    transform: "translate(0.002 0)",
    fill: "#180087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6704",
    "data-name": "Caminho 6704",
    d: "M132.679,21.439l1.581,4.874,4.775-1.812-2.819,4.257L140.6,31.37l-5.087.442.7,5.06-3.537-3.7-3.508,3.7.7-5.06-5.1-.442,4.4-2.611L126.341,24.5l4.789,1.812Z",
    transform: "translate(-105.63 15.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6705",
    "data-name": "Caminho 6705",
    d: "M162.509,26.55l.76,2.32,2.275-.859L164.2,30.039l2.088,1.243-2.436.209L164.2,33.9l-1.694-1.766L160.844,33.9l.336-2.409-2.424-.209,2.088-1.243-1.339-2.028,2.273.859Z",
    transform: "translate(-81.347 18.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6706",
    "data-name": "Caminho 6706",
    d: "M154.634,14.058l.742,2.316,2.273-.866-1.341,2.035,2.09,1.243-2.424.2.334,2.416-1.675-1.766L152.952,21.4l.336-2.416-2.424-.2,2.088-1.243-1.341-2.035,2.275.866Z",
    transform: "translate(-86.986 10.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6707",
    "data-name": "Caminho 6707",
    d: "M162.509,5.509l.76,2.32,2.275-.859L164.2,8.993l2.088,1.245-2.436.213.348,2.405L162.509,11.1l-1.665,1.759.336-2.405-2.424-.213,2.088-1.245-1.339-2.023,2.273.859Z",
    transform: "translate(-81.347 3.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6708",
    "data-name": "Caminho 6708",
    d: "M169.54,11.955l.735,2.316,2.292-.862-1.358,2.03,2.1,1.236-2.436.214.348,2.416-1.682-1.769L167.865,19.3l.334-2.416-2.429-.214,2.1-1.236-1.341-2.03,2.273.862Z",
    transform: "translate(-76.336 8.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6709",
    "data-name": "Caminho 6709",
    d: "M165,18.284l.593,1.445,1.55.113-1.185,1.006.364,1.517L165,21.539l-1.317.826.365-1.517-1.192-1.006,1.557-.113Z",
    transform: "translate(-78.416 13.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6710",
    "data-name": "Caminho 6710",
    d: "M136.161,0V9.022H113.608v9.022h22.553v9.018h9.006V18.044h22.565V9.022H145.168V0Z",
    transform: "translate(-113.606 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6711",
    "data-name": "Caminho 6711",
    d: "M113.608,0V3.026l48.068,24.036h6.044V24.036L119.66,0Z",
    transform: "translate(-113.606 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6712",
    "data-name": "Caminho 6712",
    d: "M161.676,0,113.608,24.036v3.026h6.052L167.72,3.026V0Z",
    transform: "translate(-113.606 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6713",
    "data-name": "Caminho 6713",
    d: "M137.956,0V10.825H113.608v5.413h24.348V27.062h5.411V16.238H167.72V10.825H143.367V0Z",
    transform: "translate(-113.606 0.001)",
    fill: "#ea0020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6714",
    "data-name": "Caminho 6714",
    d: "M113.607,0V2.02l14,7h4.045Zm50.08,0L145.653,9.022h4.034L167.721,0Z",
    transform: "translate(-113.607 0.001)",
    fill: "#ea0020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6715",
    "data-name": "Caminho 6715",
    d: "M131.648,10.524l-18.04,9.018h4.036l18.038-9.018Zm18.04,0,18.045,9.018V17.526l-14.011-7Z",
    transform: "translate(-113.606 7.52)",
    fill: "#ea0020"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAus);
export default __webpack_public_path__ + "static/media/flag_AUS.b9044d57f69643c92d3f7b399b1b8a0b.svg";
export { ForwardRef as ReactComponent };